import React from 'react';

import { TabButton } from '../tab-button';
import classNames from './EABD2TabBar.module.scss';

export interface TabBarProps
  extends Readonly<{
    tabs: string[];
    activeTabIndex: number;
    onSelect: (tabIndex: number) => void;
  }> {}

export const TabBar = React.memo<TabBarProps>((props) => {
  const { tabs, activeTabIndex, onSelect } = props;

  const RenderTabCallback = React.useCallback(
    (text: string, index: number) => {
      const onSelectCallback = () => onSelect(index);

      return <TabButton key={`${text}-${index}`} text={text} isActive={index === activeTabIndex} onPress={onSelectCallback} />;
    },
    [activeTabIndex, onSelect]
  );

  const ActiveTabIndicatorLineElement = React.useMemo(() => {
    const numberOfTabs = tabs.length;
    const singleTabWidthInPercent = 100 / numberOfTabs;

    const underLineElementStyle: React.CSSProperties = {
      left: `${activeTabIndex * singleTabWidthInPercent}%`,
      width: `${singleTabWidthInPercent}%`,
    };

    return <div className={classNames.activeTabIndicatorLine} style={underLineElementStyle} />;
  }, [tabs, activeTabIndex]);

  return (
    <div className={classNames.root}>
      <div className={classNames.tabsWrapper}>{tabs.map(RenderTabCallback)}</div>
      <div className={classNames.activeTabIndicatorLineWrapper}>{ActiveTabIndicatorLineElement}</div>
    </div>
  );
});
